import { render, staticRenderFns } from "./OrderCarryOut.vue?vue&type=template&id=520f70f5&scoped=true&"
import script from "./OrderCarryOut.vue?vue&type=script&lang=js&"
export * from "./OrderCarryOut.vue?vue&type=script&lang=js&"
import style0 from "./OrderCarryOut.vue?vue&type=style&index=0&id=520f70f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520f70f5",
  null
  
)

export default component.exports